import {
  Control,
  RegisterOptions,
  UseFormSetError,
  UseFormWatch,
} from "react-hook-form";
import { QuestionOption } from "./question.model";
import { SxProps } from "@mui/material";

export interface FormInputProps {
  name: string;
  control: Control<any, any>;
  label?: string;
  setValue?: any;
  rules?: RegisterOptions;
  required?: boolean;
  helperText?: string;
  setError: UseFormSetError<any>;
  watch?: UseFormWatch<any>;
  hasUpload?: boolean;
  readOnly?: boolean;
  defaultValue?: any;
  onChange?: (value: any) => void;
  sx?: SxProps;
}

export interface TableRadiosProps {
  name: string;
  control: Control<any, any>;
  helperText?: string;
  readonly?: boolean;
  options: QuestionOption[];
  localizedText: (key: string, fallback: string) => string;
  dataTestId?: string;
}

export interface FormCustomerAutoSearchProps {
  multiple?: boolean;
  selectedItemIds?: string[];
}

export enum FileType {
  "image" = "image",
  "video" = "video",
  "mp3" = "mp3",
  "file" = "file",
  "pdf" = "pdf",
  "qrcode" = "qrcode",
  "text" = "text",
  "avatar" = "avatar",
}
